<div>
	@for (button of stepRouter.activeStep().footerButtons().left; track button.id) {
		<prism-button
			[id]="button.id"
			[attr.data-testid]="button.testId ?? button.id"
			[variant]="button.variant ?? 'standard'"
			[disabled]="!(button.isEnabled?.() ?? true)"
			(click)="button.onClick(stepRouter)"
		>
			{{ button.text }}
		</prism-button>
	}
</div>

<div>
	@for (button of stepRouter.activeStep().footerButtons().right; track button.id) {
		<prism-button
			[id]="button.id"
			[attr.data-testid]="button.testId ?? button.id"
			[variant]="button.variant ?? 'standard'"
			[disabled]="!(button.isEnabled?.() ?? true)"
			(click)="button.onClick(stepRouter)"
		>
			{{ button.text }}
		</prism-button>
	}
</div>
